import { bool, arrayOf, number, func, object } from 'prop-types';
import promptStep from './promptStep';

export default {
  isOpen: bool.isRequired,
  steps: arrayOf(promptStep).isRequired,
  activeStep: number.isRequired,
  data: object,
  promptState: object,
  setPromptState: func.isRequired,
  onCancel: func.isRequired,
  onDone: func.isRequired,
  onNext: func.isRequired
};
